import { app } from '@/main';
import router from '@/router';
import webConfig from '@dts/shared/src/utils/httpUrlConfig';
import { onMounted, ref } from 'vue';

interface IPermissionListItem {
  actions: string[];
  permission: string;
}
export interface IPermission {
  mark: boolean;
  accountId?: string;
  list: IPermissionListItem[];
  username: string;
  dtsUseDays: number;
}

export const permissionKey = 'userPermission';

export const usePermission = () => {
  const userPermission = ref(false);
  const accountId = ref();
  const dept = ref('');
  const username = ref('');
  const dtsUseDays = ref(0);

  onMounted(() => {
    window.$dts.dtsAuth.permissionList.request({}).then((res) => {
      username.value = res.data?.username ?? '';
      dept.value = res.data?.dept ?? '';
      dtsUseDays.value = res.data?.dtsUseDays ?? 0;
      userPermission.value = (res.data?.roles?.length ?? 0) > 0;
      if (username.value && (import.meta.env.MODE === 'prd' || import.meta.env.MODE === 'test')) {
        const config = {
          userId: `${username.value}, ${dept.value}`,
          router,
        };
        if (window.analyzerImporter) {
          window.analyzerImporter.getAnalyzerVue(app, webConfig.appId, config);
        }
      }
    });
  });

  return {
    userPermission,
    accountId,
    dept,
    username,
    dtsUseDays,
  };
};
